import builder from '../builder';
import ArrowRight1 from '../../streamline-icons/bold/arrow-right-1.svg';
export default builder('IconArrowRight1Bold', ArrowRight1);
//# sourceMappingURL=ArrowRight1.js.map